import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BlogSection from './components/BlogSection';
import WhySection from './components/WhySection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'PandabuySpreadsheet',
  url: import.meta.env.VITE_SITE_URL,
  description: 'The ultimate curated and updated pandabuy spreadsheet for clothing, shoes, accessories and viral TikTok finds. Daily updated listings with community-verified links.',
  potentialAction: {
    '@type': 'SearchAction',
    target: import.meta.env.VITE_SITE_URL + '/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd schema={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <BlogSection />
        <WhySection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}